import { Directive, HostListener, Input, ElementRef } from '@angular/core';

import { PhoneCallBillingService } from '../services/phone-calls/phone-call-billing.service';

@Directive({
  selector: '[appPhoneCallBilling]',
})
export class PhoneCallBillingDirective {
  @Input() phoneCallContactName: string = '';
  @Input() phoneCallMatterId: number;

  private clickCount: number = 0;
  private clickTimer: any = null;

  constructor(private el: ElementRef, private phoneCallBillingService: PhoneCallBillingService) {}

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    this.clickCount++;

    if (this.clickCount === 1) {
      // First click — prevent the tel: link from firing, start timer
      event.preventDefault();
      this.clickTimer = setTimeout(() => {
        // Single click — let the tel: link fire for manual dial
        const href = this.el.nativeElement.getAttribute('href') || '';
        if (href.startsWith('tel:')) {
          window.location.href = href;
        }
        this.clickCount = 0;
      }, 400);
    } else if (this.clickCount === 2) {
      // Double click — cancel the single click timer, dial via XAPI, open modal
      event.preventDefault();
      clearTimeout(this.clickTimer);
      this.clickCount = 0;

      const href = this.el.nativeElement.getAttribute('href') || '';
      const phoneNumber = href.replace('tel:', '').trim();
      if (!phoneNumber) return;

      // Dial via tel: (hands off to 3CX softphone) and open billing modal
      window.location.href = 'tel:' + phoneNumber;

      const contactName = this.phoneCallContactName ||
        this.el.nativeElement.textContent.trim().replace(/^\s*\S+\s*/, '').trim() ||
        phoneNumber;

      this.phoneCallBillingService.openModal(phoneNumber, contactName, this.phoneCallMatterId);
    }
  }
}
